import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { t } from 'i18next';
import CreateForm from 'pages/createform';
import AutoComplete from 'components/AutoComplete';
import BasicChips from 'components/Chip';
import TextEditor from 'components/TextEditor';
import { Input, Button, Select, Modal, BrandIconSpinner } from 'components';
import MenuItem from '@mui/material/MenuItem';
import Divider from '@mui/material/Divider';
import InputAdornment from '@mui/material/InputAdornment';
import { JobForm } from './JobPosts.style';

import { ReactComponent as Exclamation } from 'assert/images/Common/exclamation.svg';
import UploadImagePreview from 'components/UploadImagePreview';
import { Notification } from 'components/CustomNotification';
import { companySizeList } from 'assert/OptionList';
import { hasTextInside, yearofExperience } from 'utils/helper';

function JobCreate({
  onChangeTab,
  state,
  setState,
  setIsDisablePreview,
  jobDetail,
}) {
  const { categoryList, jobList, workTypeList, countryList } = useSelector(
    (state) => state?.DropdownReducer
  );

  const [enableSubmit, setEnableSubmit] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [tabValue, setTabValue] = useState(0);
  const [tempLocationState, setTempLocationState] = useState({
    city: '',
    country: '',
  });
  const [errMsg, setErrmsg] = useState({
    jobTitle: '',
    // categoryId: '',
    yearOfExperience: '',
    jobTypeIds: '',
    workTypeIds: '',
    salary: '',
    location: '',
    jobDescription: '',
    howToApply: '',
    link: '',
    preTemplate: '',
    companyName: '',
    companyWebsite: '',
    companyDescription: '',
  });

  useEffect(() => {
    if (enableSubmit !== null) {
      const validation = Object.keys(errMsg).every((it) => errMsg[it] === '');
      if (validation) {
        onChangeTab(1);
        const data = { ...state };
        data.jobDescription = state.jobDescription;
          // ?.replace(/&nbsp;&nbsp;+/g, '')
          // ?.replace(/<p><br><\/p>/g, '');
        data.companyDescription = state.companyDescription;
          // ?.replace(/&nbsp;&nbsp;+/g, '')
          // ?.replace(/<p><br><\/p>/g, '');
        setState(data);
        setIsDisablePreview(false);
      } else {
        Notification('info', 'Fill all the required fields');
      }
    }
  }, [enableSubmit, errMsg]);

  const handleValidation = useCallback(() => {
    const validationParams = { ...errMsg };

    if (!state.jobTitle?.trim()) validationParams.jobTitle = 'Job Title is required';
    else validationParams.jobTitle = '';

    if (!state.yearOfExperience) validationParams.yearOfExperience = 'Year of Experience is required';
    else validationParams.yearOfExperience = '';

    // if (!state?.categoryId)
    //   validationParams.categoryId = 'Category is required';
    // else validationParams.categoryId = '';

    if (!state?.jobTypeIds?.length > 0)
      validationParams.jobTypeIds = t('Job.SelectEmployment');
    else validationParams.jobTypeIds = '';

    if (!state?.workTypeIds?.length > 0)
      validationParams.workTypeIds = t('Job.SelectWork');
    else validationParams.workTypeIds = '';

    if (!state.workTypeIds.includes(4) && state.location?.length === 0)
      validationParams.location = t('Job.AddLocation');
    else validationParams.location = '';

    if (!state.jobDescription || !hasTextInside(state.jobDescription))
      validationParams.jobDescription = 'Job Description is required';
    else validationParams.jobDescription = '';

    if (!state.link && !state.preTemplate)
      validationParams.howToApply = t('Job.SelectOption');
    else validationParams.howToApply = '';

    if (
      /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(state.link) ||
      /^(?:(?:https?|ftp):\/\/)?(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,6}(?:\/[^\s]*)?$/gi.test(
        state.link
      )
    ) {
      validationParams.link = '';
    } else validationParams.link = !state.link ? '' : 'Invalid value';

    if (!state.companyName?.trim())
      validationParams.companyName = 'Company Name is required';
    else validationParams.companyName = '';

    if (
      !state.companyWebsite ||
      !/(https?:\/\/)?([\da-z.-]+)\.([a-z]{2,6})([/\w.-]*)*\/?/g.test(
        state.companyWebsite
      )
    ) {
      validationParams.companyWebsite = t('Job.InvalidUrl');
    } else validationParams.companyWebsite = '';

    if (!state.companyDescription || !hasTextInside(state.companyDescription))
      validationParams.companyDescription = 'Company Description is required';
    else validationParams.companyDescription = '';

    setErrmsg(validationParams);
  }, [errMsg, state]);

  const handleChange = (data, name) => {
    if(name === "companyLogo" && data.length > 1) {
      Notification('warning', "You can't upload more than one photo");
      data = [data[0]];
    }
    setState((prevState) => ({
      ...prevState,
      [name]: data?.target?.value || data,
    }));
    if (name === 'link') {
      setState((prevState) => ({
        ...prevState,
        preTemplate: '',
      }));
    }
  };

  const handleLocationChange = (data, name) => {
    setTempLocationState((prevState) => ({
      ...prevState,
      [name]: data?.label || data,
    }));
  };

  const handleLocationAdd = () => {
    setState((prevState) => ({
      ...prevState,
      location: [
        ...state.location,
        { country: tempLocationState.country, city: tempLocationState.city, name: tempLocationState.country },
      ],
    }));
    setTempLocationState({
      city: '',
      country: '',
    });
    if (state.location.length === 0) {
      const validationParams = { ...errMsg };
      validationParams.location = '';
      setErrmsg(validationParams);
    }
  };

  const handleLocationDelete = (deleteKey) => {
    setState((prevState) => ({
      ...prevState,
      location: state.location.filter((_, index) => index !== deleteKey),
    }));
    if (state.location.length === 1) {
      const validationParams = { ...errMsg };
      validationParams.location = 'Add atleast one location';
      setErrmsg(validationParams);
    }
  };

  const handleSubmit = () => {
    handleValidation();
    setEnableSubmit(!enableSubmit);
  };

  const handleModalClose = (data, element) => {
    setState((prevState) => ({
      ...prevState,
      preTemplate: data,
      link: '',
    }));
    setModalOpen(false);
    if (data) {
      const validationParams = { ...errMsg };
      validationParams.howToApply = '';
      setErrmsg(validationParams);
    }
    if (data === 'Custom Template') {
      setState((prevState) => ({
        ...prevState,
        template: element,
      }));
    }
  };

  const handleDelete = () => {
    setState((prevState) => ({
      ...prevState,
      preTemplate: '',
    }));
    const validationParams = { ...errMsg };
    validationParams.howToApply = 'Select atleast one option';
    setErrmsg(validationParams);
  };

  if (
    categoryList?.length === 0 ||
    jobList?.length === 0 ||
    workTypeList?.length === 0 ||
    countryList.length === 0
  )
    return <BrandIconSpinner loading />;

  const errorMessage = (errMsg) => {
    return (
      errMsg && (
        <span className="errMsg">
          <Exclamation />
          {errMsg}
        </span>
      )
    );
  };

  const handleModalOpen = () => {
    setModalOpen(true);
    if (state?.preTemplate === 'Template 1') {
      setTabValue(0);
    } else if (state?.preTemplate === 'Template 2') {
      setTabValue(1);
    } else if (state?.preTemplate === 'Custom Template') {
      setTabValue(2);
    }
  };

  return (
    <JobForm>
      <h2 className="job-form-title">{t(`Job.AboutThePosition`)}</h2>
      <div className="field-wrap">
        <Input
          label={t('Job.JobTitle')}
          placeholder={'e.g. Software Developer'}
          required
          value={state.jobTitle}
          onChange={(data) => handleChange(data, 'jobTitle')}
          errMsg={errMsg.jobTitle}
        />
        <Select
          label={t('Job.YearOfExperience')}
          Options={yearofExperience()}
          required
          value={state.yearOfExperience}
          onChange={(data) => handleChange(data, 'yearOfExperience')}
          errMsg={errMsg.yearOfExperience}
        />
        {/* <Select
          Options={categoryList}
          label={t('jobs.category')}
          required
          value={state.categoryId}
          onChange={(data) => handleChange(data, 'categoryId')}
          errMsg={errMsg.categoryId}
        /> */}
      </div>
      <div className="field-employment">
        <Select
          Options={jobList}
          label={t('Job.EmploymentType')}
          required
          value={state.jobTypeIds}
          onChange={(data) => handleChange(data, 'jobTypeIds')}
          mode="multiple"
          errMsg={errMsg.jobTypeIds}
        />
      </div>
      <div className="field-wrap">
        <Select
          Options={workTypeList}
          label={t('Job.WorkType')}
          required
          value={state.workTypeIds}
          errMsg={errMsg.workTypeIds}
          mode="multiple"
          onChange={(data) => handleChange(data, 'workTypeIds')}
          customOptions={workTypeList.map((data, index) => {
            if (index === 3) {
              return [
                <div key={index} style={{ display: 'flex', justifyContent: 'center' }}>
                  <Divider style={{ width: 150 }}>OR</Divider>
                </div>,
                <MenuItem
                  disabled={
                    state.workTypeIds.length > 0 &&
                    !state.workTypeIds.includes(4)
                  }
                  key={data.value}
                  value={data.value}
                >
                  {data.label}
                </MenuItem>,
              ];
            }
            return (
              <MenuItem
                disabled={state.workTypeIds.includes(4)}
                key={data.value}
                value={data.value}
              >
                {data.label}
              </MenuItem>
            );
          })}
        />
        <Input
          maxLimit={10}
          label={t('Job.Salary')}
          value={state.salary}
          placeholder={t('Job.ExampleSalary')}
          onChange={(data) => handleChange(data, 'salary')}
        />
      </div>
      {!state.workTypeIds.includes(4) && (
        <>
          <div className="field-wrap-btn">
            <AutoComplete
              Options={countryList}
              label={t('Job.Country')}
              value={tempLocationState.country}
              onChange={(data) => handleLocationChange(data, 'country')}
              disabled={state.location.length >= 5}
              freeSolo
            />
            <Input
              label={t('Job.City')}
              value={tempLocationState.city}
              onChange={(data) => handleLocationChange(data, 'city')}
              disabled={state.location.length >= 5}
            />
            <Button
              type="outlined"
              disabled={
                !tempLocationState.country ||
                state.location.length >= 5
              }
              label={t('Job.Add')}
              onClick={handleLocationAdd}
            />
          </div>
          {errorMessage(errMsg.location)}
          <div className="job-chip-container">
            {state.location.map((item, index) => (
              <BasicChips
                key={'location_' + index}
                label={
                  item?.city
                    ? item?.country + ', ' + item.city
                    : item.country
                }
                onDelete={() => handleLocationDelete(index)}
              />
            ))}
          </div>
        </>
      )}
      <TextEditor
        label={t('Job.Description')}
        required
        value={state.jobDescription}
        errMsg={errMsg.jobDescription}
        onChange={(data) => handleChange(data, 'jobDescription')}
        maxLength={10000}
        customStyle={'job-text-editor'}
      />
      <div>
        <h2 className="job-form-title">{t('Job.HowToApply')}</h2>
        {errorMessage(errMsg.howToApply)}
        <Input
          label={t('Job.LinkToApply')}
          value={state.link}
          onChange={(data) => handleChange(data, 'link')}
          maxLimit={1000}
        />
        {errorMessage(errMsg.link)}
        <div className="job-or">
          <Divider>{t('Job.Or')}</Divider>
        </div>
        <Button
          customStyles="job-select-btn"
          type="outlined"
          label={t('Job.Site')}
          onClick={handleModalOpen}
        />
        {state.preTemplate ? (
          <BasicChips
            className="selected-template"
            label={'Selected ' + state.preTemplate}
            onDelete={handleDelete}
          />
        ) : (
          ''
        )}
      </div>
      <h2 className="job-form-title">{t('Job.AboutTheCompany')}</h2>
      <div className="job-img-wrap">
        <UploadImagePreview
          isReplace
          isDelete
          maxFiles={1}
          handleFileSRC={(data) => handleChange(data, 'companyLogo')}
          value={state.companyLogo || ''}
          // showIcon
          onCloseFiles={(data) => {
            setState((prevState) => ({
              ...prevState,
              companyLogo: [],
              attachment: data?.startsWith('https://') && data
            }));
          }}
          types="imageupload"
          label={t('Job.cmyLogo')}
        />
        <div>
          <Input
            label={t('Job.cmyName')}
            required
            value={state.companyName}
            onChange={(data) => handleChange(data, 'companyName')}
            errMsg={errMsg.companyName}
          />
          <Select
            Options={companySizeList}
            label={t('Job.cmySize')}
            value={state.companySize}
            onChange={(data) => handleChange(data, 'companySize')}
            errMsg={errMsg.companySize}
          />
        </div>
      </div>
      <Input
        label={t('Job.cmyurl')}
        placeholder={'www.example.com'}
        required
        value={state.companyWebsite}
        onChange={(data) => handleChange(data, 'companyWebsite')}
        startAdornment={
          <InputAdornment position="start">https://</InputAdornment>
        }
      />
      {errMsg.companyWebsite && (
        <span className="errMsg">
          <Exclamation />
          {errMsg.companyWebsite}
        </span>
      )}
      <TextEditor
        label={t('Job.CmyDescription')}
        required
        errMsg={errMsg.companyDescription}
        onChange={(data) => handleChange(data, 'companyDescription')}
        value={state.companyDescription}
        maxLength={5000}
        customStyle={'job-text-editor'}
      />
      <div className="job-preview-submit">
        <Button label={t('Job.Preview')} onClick={handleSubmit} />
      </div>
      <Modal
        content={
          <CreateForm
            handleTabChange={setTabValue}
            closeModal={() => setModalOpen(!modalOpen)}
            handleSelectTemplate={handleModalClose}
            jobDetail={jobDetail}
            tabValue={tabValue || 0}
          />
        }
        openModal={modalOpen}
        handleCancelModal={() => setModalOpen(!modalOpen)}
        modelTitle={t('Job.SelectTemplate')}
        modalchanges={tabValue === 1 ? 'job-template' : 'job-custom-template'}
      />
    </JobForm>
  );
}

export default JobCreate;
